<template>
  <div class="page-container">
    <b-modal
      size="lg"
      id="upload-image"
      v-model="hasImageToUpload"
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <template #modal-title>
        Wgrywanie zdjęcia - {{ editUser.first_name }} {{ editUser.last_name }}
      </template>
      <div class="text-center">
        <div class="loading-overlay" v-if="isUploadingFile">
          <b-spinner></b-spinner>
        </div>
        <div class="upload-example">
          <cropper
            ref="cropper"
            :min-height="minHeight"
            :src="image.src"
            :stencil-props="stencilProps"
          />
          <div class="vertical-buttons">
            <div class="square-button" @click="rotate(90)">
              <font-awesome-icon icon="redo" style="color: white;" />
            </div>
            <div class="square-button" @click="rotate(-90)">
              <font-awesome-icon icon="undo" style="color: white;" />
            </div>
            <div class="square-button" @click="changeAspectRatio">
              <font-awesome-icon icon="expand" style="color: white;" />
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3 d-flex flex-row justify-content-center" style="gap: 0.5rem;">
        <b-button variant="primary" :disabled="isUploadingFile" @click="crop">Wgraj</b-button>
        <b-button @click="reset" :disabled="isUploadingFile">Anuluj</b-button>
      </div>
    </b-modal>
    <div class="button-wrapper">
      <input hidden type="file" ref="file" @change="loadImage($event)" accept="image/*" />
    </div>
    <b-table
      :items="doctorsTable.items"
      :fields="doctorsTable.fields"
      :sort-by.sync="doctorsTable.sortBy"
      :sort-desc.sync="doctorsTable.sortDesc"
      show-empty
      stacked="md"
      :current-page="doctorsTable.currentPage"
      :per-page="doctorsTable.perPage"
    >
      <template v-slot:cell(picture)="{ item }">
        <div style="position: relative;">
          <div v-if="isUpdatingList && lastUpdatedUser === item.id" class="image-spinner-overlay">
            <b-spinner small></b-spinner>
          </div>
          <img
            :src="item.picture_url"
            alt="zdjęcie"
            @load="onFileLoad(item)"
            @click="show(item.picture_url)"
            style="height: 50px;"
          />
        </div>
      </template>
      <template v-slot:cell(updated_at)="row">
        {{ row.item.updated_at | formatDate }}
      </template>
      <template v-slot:cell(actions)="row">
        <b-button-group>
          <b-button class="btn-primary mr-1" size="sm" @click="editDoctor(row)"
            >Aktualizuj zdjęcie</b-button
          >
          <b-button
            v-show="containDefaultAvatar(row.item)"
            class="btn-danger"
            size="sm"
            @click="deleteDoctorPicture(row)"
            >Usuń</b-button
          >
        </b-button-group>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="doctorsTable.currentPage"
          :total-rows="doctorsTable.items.length"
          :per-page="doctorsTable.perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <vue-easy-lightbox
      :visible="visible"
      :imgs="imgs"
      :index="index"
      @hide="handleHide"
      :scrollDisabled="true"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { Cropper } from 'vue-advanced-cropper'
import axios from 'axios'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-advanced-cropper/dist/style.css'
import 'vue-advanced-cropper/dist/theme.classic.css'
import moment from 'moment'
import VueEasyLightbox from 'vue-easy-lightbox'
import getMimeType from '@/utils/getMimeType'

export default {
  name: 'All-Staff',
  components: {
    Cropper,
    VueEasyLightbox
  },
  async mounted() {
    const vm = this
    moment.locale('pl')
    vm.fetchStaffList()
  },
  data() {
    return {
      aspectRatio: 'empty',
      hasImageToUpload: false,
      lastUpdatedUser: null,
      isUpdatingList: false,
      isUploadingFile: false,
      imgs: '',
      visible: false,
      index: 0,
      editUser: {
        user_id: null,
        first_name: null,
        last_name: null
      },
      image: {
        src: null,
        type: null
      },
      doctorsTable: {
        currentPage: 1,
        perPage: 10,
        sortBy: 'first_name',
        sortDesc: false,
        fields: [
          { key: 'picture', label: '' },
          { key: 'title', label: 'Tytuł' },
          { key: 'first_name', label: 'Imię', sortable: true },
          { key: 'last_name', label: 'Nazwisko', sortable: true },
          { key: 'updated_at', label: 'Data ostatniej edycji', sortable: true },
          { key: 'actions', label: 'Akcje' }
        ],
        items: []
      }
    }
  },
  computed: {
    minHeight() {
      return this.aspectRatio !== 'empty' ? 400 : 0
    },
    stencilProps() {
      let ratio = 16 / 9

      switch (this.aspectRatio) {
        case '1/1':
          ratio = 1
          break
        case '16/9':
          ratio = 16 / 9
          break
        case '9/16':
          ratio = 9 / 16
          break
        case 'empty':
        default:
          ratio = null
      }

      if (!ratio) {
        return {
          movable: true,
          resizable: true
        }
      }

      return {
        aspectRatio: ratio,
        movable: true,
        resizable: true
      }
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return '---'
      // format value to this from 2024-07-01T20:20:33.000Z to YYYY-MM-dd hh:mm:ss use moment
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    deleteDoctorPicture(row) {
      this.$http
        .post('e-zacma/delete_tablet_member_picture', {
          userId: row.item.id
        })
        .then(() => {
          this.lastUpdatedUser = row.item.id
          this.fetchStaffList()
        })
    },
    containDefaultAvatar(item) {
      return !item.picture_url.includes('default-avatar')
    },
    show(imgURL) {
      this.imgs = imgURL
      this.visible = true
    },
    changeAspectRatio() {
      const currentAspectRatio = this.aspectRatio
      switch (currentAspectRatio) {
        case '1/1':
          this.aspectRatio = '16/9'
          break
        case '16/9':
          this.aspectRatio = '9/16'
          break
        case '9/16':
          this.aspectRatio = 'empty'
          break
        case 'empty':
        default:
          this.aspectRatio = '1/1'
      }
    },
    rotate(angle) {
      this.$refs.cropper.rotate(angle)
    },
    handleHide() {
      this.visible = false
    },
    onFileLoad(item) {
      if (this.lastUpdatedUser === item.id) {
        this.isUpdatingList = false
        this.lastUpdatedUser = null
      }
    },
    async crop() {
      this.isUploadingFile = true
      const { canvas } = this.$refs.cropper.getResult()
      canvas.toBlob(async blob => {
        try {
          const response = await this.$http.post(
            'e-zacma/generate-presigned-url-to-upload-avatar',
            {
              userId: this.editUser.user_id
            }
          )

          const { url, fileName, s3BucketName, s3Region, directoryName } = response.data
          const instance = axios.create()
          delete instance.defaults.headers.common.Authorization

          await instance.put(url, blob, {
            headers: {
              'Content-Type': 'image/jpeg'
            }
          })

          const fileKey = `${directoryName}/${fileName}`
          const fileUrl = `https://${s3BucketName}.s3.${s3Region}.amazonaws.com/${fileKey}`

          await this.$http.post('e-zacma/update_tablet_member', {
            userId: this.editUser.user_id,
            fileUrl,
            fileKey
          })

          this.$toast.success({
            title: 'Zdjęcie zostało zaktualizowane.',
            message: 'Lista zostanie odświeżona automatycznie.'
          })
          this.lastUpdatedUser = this.editUser.user_id
          this.fetchStaffList()
        } catch (error) {
          this.$toast.error({
            title: 'Wystąpił błąd podczas aktualizacji zdjęcia.',
            message: 'Spróbuj ponownie za jakiś czas lub skontaktuj się z działem technicznym.'
          })
        } finally {
          this.reset()
          this.isUploadingFile = false
        }
      }, this.image.type)
    },
    reset() {
      this.image = {
        src: null,
        type: null
      }
      this.editUser = {
        user_id: null
      }
      this.hasImageToUpload = false
      this.$refs.file.value = null
    },
    loadImage(event) {
      // Reference to the DOM input element
      const { files } = event.target
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src)
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0])

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type)
          }
          this.hasImageToUpload = true
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0])
      } else {
        this.editUser = {
          user_id: null
        }
      }
    },
    fetchStaffList() {
      const vm = this
      if (!this.lastUpdatedUser) {
        vm.$store.commit('addPageLoaderEvent', 'staffList')
      } else {
        vm.isUpdatingList = true
      }

      vm.$http.post('e-zacma/get_tablet_staff_list').then(response => {
        vm.doctorsTable.items = response.data
        vm.$store.commit('removePageLoaderEvent', 'staffList')
      })
    },
    editDoctor(row) {
      this.aspectRatio = 'empty'
      this.editUser = {
        user_id: row.item.id,
        first_name: row.item.first_name,
        last_name: row.item.last_name
      }
      this.$refs.file.click()
    }
  },
  destroyed() {
    // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src)
    }
  }
}
</script>

<style lang="scss">
.upload-example {
  overflow: hidden;
  position: relative;
  height: 50vh;
  display: flex;
  align-content: center;
  justify-content: center;

  & .vertical-buttons {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);

    & .square-button {
      background: rgba(black, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 42px;
      width: 42px;
      margin-bottom: 10px;
      cursor: pointer;
      transition: background 0.5s;
      &:hover {
        background: rgba(grey, 0.5);
      }
    }
  }

  &__cropper {
    border: solid 1px #eee;
    min-height: 300px;
    max-height: 500px;
    width: 100%;
  }

  &__cropper-wrapper {
    position: relative;
  }

  &__reset-button {
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 42px;
    background: rgba(#3fb37f, 0.7);
    transition: background 0.5s;
    &:hover {
      background: #3fb37f;
    }
  }

  &__buttons-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 17px;
  }

  &__button {
    border: none;
    outline: solid transparent;
    color: white;
    font-size: 16px;
    padding: 10px 20px;
    background: #3fb37f;
    cursor: pointer;
    transition: background 0.5s;
    margin: 0 16px;
    &:hover,
    &:focus {
      background: #38d890;
    }
    input {
      display: none;
    }
  }

  &__file-type {
    position: absolute;
    top: 20px;
    left: 20px;
    background: #0d0d0d;
    border-radius: 5px;
    padding: 0px 10px;
    padding-bottom: 2px;
    font-size: 12px;
    color: white;
  }
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.image-spinner-overlay {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: rgb(255 255 255 / 60%);
}
</style>
